import { useEffect } from 'react';
import { useAppDispatch } from '../store/hooks';
import { setAuthState, clearAuthState } from '../store/slices/authSlice';

export default function AuthInitializer({ children }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Check if there's existing auth data in localStorage
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');
    const userData = localStorage.getItem('user');

    if (accessToken && userData) {
      try {
        const user = JSON.parse(userData);
        dispatch(setAuthState({
          user,
          accessToken,
          refreshToken
        }));
      } catch (error) {
        console.error('Error parsing stored user data:', error);
        // Clear invalid data
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        dispatch(clearAuthState());
      }
    } else {
      // Clear any partial data
      dispatch(clearAuthState());
    }
  }, [dispatch]);

  return children;
}
